<template>
  <VField
    class="mb-6"
    error-class="mt-1"
    :error="validationError"
  >
    <label
      :for="'postalCode'"
      class="text-white text-sm"
    >
      {{ $t('attributes.postalCode') }}:
    </label>
    <VInput
      :class="$style['input']"
      v-model="postalCode"
      :valid="isValid"
      :invalid="isInvalid"
      @blur="onBlur"
    />
  </VField>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'

import {
  VField,
  VInput
} from '@c/base'

export default {
  components: {
    VField,
    VInput
  },

  props: {
    value: {
      type: String,
      required: true
    },
    backValidationError: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      postalCode: this.value
    }
  },

  computed: {
    validationError () {
      if (this.backValidationError) {
        return this.backValidationError
      }

      if (this.$v.postalCode.$error) {
        return !this.$v.postalCode.required
          ? this.$t('validate.required', { attribute: this.$t('attributes.postalCode') })
          : this.$t('validate.maxLength', { attribute: this.$t('attributes.postalCode'), max: 100 })
      }

      return ''
    },

    isValid () {
      return !this.backValidationError &&
             !this.$v.postalCode.$error &&
             this.$v.postalCode.required &&
             this.$v.postalCode.maxLength
    },

    isInvalid () {
      return !!this.backValidationError ||
             this.$v.postalCode.$error
    }
  },

  methods: {
    onBlur () {
      this.$v.postalCode.$touch()

      this.$emit('input', this.postalCode)
    }
  },

  validations: {
    postalCode: {
      required,
      maxLength: maxLength(100)
    }
  }
}
</script>

<style module>
.input {
  height: 10px;
}
</style>
